/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EmailNotificationPreferences } from './emailNotificationPreferences';

/**
 * API model for per-user notification preferences.
 */
export interface UserNotificationPreferences {
  email?: EmailNotificationPreferences;
}
